import { createAction, props } from '@ngrx/store';
import { OfferWithImage } from '@/model/offer-with-image';

export const loadAdvisoryBoardOffers = createAction(
  '[Advisory Board Offers] Load Advisory Board Offers',
  props<{ categoryIds: string[] }>(),
);

export const loadAdvisoryBoardOffersSuccess = createAction(
  '[Advisory Board Offers] Load Advisory Board Offers Success',
  props<{ offers: OfferWithImage[] }>(),
);

export const loadAdvisoryBoardOffersFailure = createAction(
  '[Advisory Board Offers] Load Advisory Board Offers Failure',
  props<{ error: string }>(),
);

export const clearAdvisoryBoardOffers = createAction(
  '[Advisory Board Offers] Clear Advisory Board Offers',
);
